import React from "react";
import {
  ProductCardDateValuesType,
  ProductCardIsinToNameType,
} from "types/AssistantTypes";
import styles from "./rendimentiAndamentoCompareContainer.module.scss";
import RendimentiChartCompare from "./RendimentiChartCompare";
import { useTranslation } from "react-i18next";

type RendimentiAndamentoCompareContainerProps = {
  andamento: ProductCardDateValuesType[];
  drawdown: ProductCardDateValuesType[];
  performanceProducts: string[];
  isinToName: ProductCardIsinToNameType;
};

const RendimentiAndamentoCompareContainer: React.FC<
  RendimentiAndamentoCompareContainerProps
> = ({ andamento, drawdown, performanceProducts, isinToName }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <h2 className={styles.sectionTitle}>
        {t("productCard.rendimentiAndamentoTitle")}
      </h2>
      <div style={{ marginBottom: 24 }}>
        <RendimentiChartCompare
          andamento={andamento}
          performanceProducts={performanceProducts}
          isinToName={isinToName}
        />
      </div>
      <RendimentiChartCompare
        andamento={drawdown}
        performanceProducts={performanceProducts}
        isinToName={isinToName}
        useYAxisPercentage
      />
    </div>
  );
};

export default RendimentiAndamentoCompareContainer;
